/**
 * Animations settings are stored here
 */
export const ANIMATIONS = {
    speed: {
        default: '225ms',
        slow: '450ms',
        leave: '195ms'
    },
    bezierCurve: {
        default: 'ease-in-out'
    }
};
